module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "staff-boxs"
  }, [_c('div', {
    staticClass: "cont-top m-b-30 com-model flex flex-column align-initial flex-between"
  }, [_c('div', {
    staticClass: "cont-title flex flex-between",
    staticStyle: {
      "padding-right": "40px"
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_vm._v("\n        组织架构\n        "), _c('div', {
    staticClass: "primary-btn m-l-24",
    on: {
      "click": function($event) {
        _vm.goadd(1)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus m-r-10"
  }), _vm._v("新增员工\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "primary-border-btn m-l-24",
    on: {
      "click": _vm.gochangeadm
    }
  }, [_vm._v("更换管理员")])]), _vm._v(" "), _c('el-tabs', {
    staticClass: "ac-tabs",
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.tabindex),
      callback: function($$v) {
        _vm.tabindex = $$v
      },
      expression: "tabindex"
    }
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "index": index,
        "label": item,
        "name": index.toString()
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "staffbox",
    staticStyle: {
      "padding-top": "4px"
    }
  }, [_c('div', {
    staticClass: "com-model",
    staticStyle: {
      "padding": "32px 25px 40px"
    }
  }, [(Number(_vm.tabindex) <= 1) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.rowslist
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "headImage",
      "label": "头像",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "40px",
            "height": "40px",
            "border-radius": "50%"
          },
          attrs: {
            "src": scope.row.headImage ? scope.row.headImage : '//oss.51ztx.com/face.png',
            "alt": ""
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nickName",
      "label": "姓名",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机/账号",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "workDesc",
      "label": "职位",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(Number(_vm.tabindex) === 0) ? [_c('el-button', {
          staticClass: "staff-btn primary-border-btn",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.hrDisable(scope.row.id)
            }
          }
        }, [_vm._v("\n                停用\n              ")]), _vm._v(" "), _c('el-button', {
          staticClass: "staff-btn primary-btn",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.hrEdit(2, scope.row)
            }
          }
        }, [_vm._v("\n                编辑\n              ")])] : [_c('el-button', {
          staticClass: "staff-btn primary-border-btn",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.hrDelete(scope.row.id)
            }
          }
        }, [_vm._v("\n                删除\n              ")]), _vm._v(" "), _c('el-button', {
          staticClass: "staff-btn primary-btn",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.hrEnable(scope.row.id)
            }
          }
        }, [_vm._v("\n                启用\n              ")])]]
      }
    }])
  })], 1) : _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.rowslist
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "headImage",
      "label": "头像",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": scope.row.headImage ? scope.row.headImage : '//oss.51ztx.com/face.png',
            "alt": ""
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nickName",
      "label": "姓名",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机/账号",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userId",
      "label": "验证信息",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "staff-btn primary-border-btn",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.hrDisable(scope.row.id)
            }
          }
        }, [_vm._v("\n              拒绝\n            ")]), _vm._v(" "), _c('el-button', {
          staticClass: "staff-btn primary-btn",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.passJoin(scope.row.id)
            }
          }
        }, [_vm._v("\n              通过\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total),
      expression: "total"
    }],
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "current-page": _vm.pageNum,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "show": _vm.modalshow,
      "modal-title": _vm.confirmTitle,
      "cancel-button-text": _vm.canceTxt,
      "confirm-button-text": _vm.confirmTxt
    },
    on: {
      "cancelHander": _vm.cancel,
      "conformHander": _vm.conform
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [(_vm.modalType === 1) ? _c('div', [_c('div', {
    staticClass: "ztx-mess-item clearfix"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ztx-mess-name"
  }, [_vm._v("手机")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "ztx-mess-inp",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "blur": _vm.getisReg,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ztx-mess-tx"
  }, [_vm._v(_vm._s(_vm.phoneerror))])]), _vm._v(" "), _c('div', {
    staticClass: "ztx-mess-item clearfix"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ztx-mess-name"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nickName),
      expression: "nickName"
    }],
    staticClass: "ztx-mess-inp",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nickName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nickName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ztx-mess-tx"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ztx-mess-item clearfix"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ztx-mess-name"
  }, [_vm._v("职位")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workDesc),
      expression: "workDesc"
    }],
    staticClass: "ztx-mess-inp",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.workDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.workDesc = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.isreg) ? _c('div', {
    staticClass: "ztx-mess-item clearfix"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ztx-mess-name"
  }, [_vm._v("设置密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "ztx-mess-inp",
    attrs: {
      "type": "password",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.modalType === 2) ? _c('div', [_c('div', {
    staticClass: "ztx-mess-item clearfix"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ztx-mess-name"
  }, [_vm._v("手机")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemPhone),
      expression: "itemPhone"
    }],
    staticClass: "ztx-mess-inp",
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.itemPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ztx-mess-tx"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ztx-mess-item clearfix"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ztx-mess-name"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemNickName),
      expression: "itemNickName"
    }],
    staticClass: "ztx-mess-inp",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.itemNickName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemNickName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ztx-mess-tx"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ztx-mess-item clearfix"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ztx-mess-name"
  }, [_vm._v("职位")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemWorkDesc),
      expression: "itemWorkDesc"
    }],
    staticClass: "ztx-mess-inp",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.itemWorkDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.itemWorkDesc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ztx-mess-tx"
  })])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c004fb70","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staff/list.vue
// module id = 907
// module chunks = 1